/**
 * Pure helpers behind the step drawer's Connection picker.
 *
 * Both the grouping below and the ElOption template dereference `connection.connector`, so a
 * connection whose connector row is missing (the backend returns it as null - see
 * ConnectionServiceImpl#findAllByOrganization) must never reach them. Filtering happens once, in
 * getShownConnections, so a single orphaned connection cannot break the picker for the whole tenant.
 */

export interface PickerConnector {
  connectorSpecId?: string;
  connectorType?: string;
  hasConsumer?: boolean;
}

export interface PickerConnection {
  id?: string;
  name?: string;
  active?: boolean;
  connectionOptional?: boolean;
  connector?: PickerConnector | null;
}

export interface ShownConnectionsOptions {
  stepIdx: number;
  isStepInRouter: boolean;
  stepIx?: number;
  webhookConnectorSpecId: string;
}

export interface ConnectionGroup {
  label: string;
  options: PickerConnection[];
}

export function getShownConnections(
  connections: PickerConnection[] | undefined | null,
  options: ShownConnectionsOptions
): PickerConnection[] {
  const usable = (connections || []).filter(
    (connection) => connection?.connector
  );

  if (options.stepIdx === 0 && !options.isStepInRouter) {
    return usable.filter((connection) => connection.connector.hasConsumer);
  }
  if (options.stepIx !== 0) {
    return usable.filter(
      (connection) =>
        connection.connector.connectorSpecId !== options.webhookConnectorSpecId
    );
  }
  return usable;
}

export function groupConnections(
  shownConnections: PickerConnection[]
): ConnectionGroup[] {
  return [
    {
      label: "Common.Core",
      options: shownConnections.filter(
        (connection) =>
          !connection.connectionOptional &&
          connection.connector.connectorType === "CORE"
      ),
    },
    {
      label: "Common.Prime",
      options: shownConnections.filter(
        (connection) =>
          !connection.connectionOptional &&
          connection.connector.connectorType === "EXTERNAL"
      ),
    },
    {
      label: "Common.Tools",
      options: shownConnections.filter(
        (connection) => connection.connectionOptional
      ),
    },
  ];
}
